import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";
import ClassSelect from "../../../components/common-input/ClassSelect";
import FileUpload from "../../../components/common/FileUpload";
import { Student } from "../../../types/studentType";

type Props = {
  data: Partial<Student>;
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void;
  onPhotoUpload?: (url: string) => void;
  isEditing?: boolean;
};

export default function StudentProfileInfo({
  data,
  onChange,
  onPhotoUpload,
  isEditing = true,
}: Props) {
  return (
    <div className="md:flex gap-3 md:gap-6">
      <div className="flex flex-col w-full gap-6">
        <CustomInput
          name="fullName"
          label="Student Name"
          placeholder="Enter student name"
          value={data.fullName ?? ""}
          onChange={onChange}
          inputClassName="w-full"
          readOnly={!isEditing}
          required
        />

        <CustomInput
          name="dateOfBirth"
          type="date"
          label="Date of Birth"
          value={data.dateOfBirth ?? ""}
          onChange={onChange}
          inputClassName="w-full"
          readOnly={!isEditing}
          required
        />

        <ClassSelect
          name="classSection"
          label="Admission for Class"
          value={data.classSection ?? ""}
          placeholder="Select class"
          onChange={onChange}
        />

        <CustomSelect
          name="admissionYear"
          label="Academic Year"
          value={data.admissionYear ?? ""}
          options={[
            { label: "2026-27", value: 2026 },
            { label: "2027-28", value: 2027 },
            { label: "2028-29", value: 2028 },
          ]}
          placeholder="Select academic year"
          onChange={onChange}
          required
        />

        <CustomInput
          name="previousSchoolName"
          label="Previous School Name"
          placeholder="Enter previous school name"
          value={data.previousSchoolName ?? ""}
          onChange={onChange}
          inputClassName="w-full"
        />

        <CustomSelect
          name="studentCategory"
          label="Student Category"
          value={data?.studentCategory}
          options={[
            { label: "General", value: "GENERAL" },
            { label: "OBC", value: "OBC" },
            { label: "SC", value: "SC" },
            { label: "ST", value: "ST" },
          ]}
          placeholder="Select student category"
          onChange={onChange}
          required
        />

        <div className="flex  gap-4">
          <div className="flex gap-1">
            <label className="text-sm font-semibold text-neutral-600">
              Gender
            </label>
            <span className="text-error-500">*</span>
          </div>
          <div className="flex gap-8">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="gender"
                value="MALE"
                checked={data.gender === "MALE"}
                onChange={onChange}
                disabled={!isEditing}
                className="accent-primary-600"
              />
              <span className="text-sm">Male</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="gender"
                value="FEMALE"
                checked={data.gender === "FEMALE"}
                onChange={onChange}
                disabled={!isEditing}
                className="accent-primary-600"
              />
              <span className="text-sm">Female</span>
            </label>
          </div>
        </div>

        {/* <div className="flex gap-4">
          <label className="text-sm font-semibold text-neutral-600">
            Opt for daycare?
          </label>
          <div className="flex gap-8">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="optForDaycare"
                value="true"
                checked={data.optForDaycare === true}
                onChange={onChange}
                disabled={!isEditing}
                className="accent-primary-600"
              />
              <span className="text-sm">Yes</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="optForDaycare"
                value="false"
                checked={data.optForDaycare === false}
                onChange={onChange}
                disabled={!isEditing}
                className="accent-primary-600"
              />
              <span className="text-sm">No</span>
            </label>
          </div>
        </div> */}
      </div>

      <div className="flex justify-start items-start mt-3">
        <FileUpload
          value={data.photoUrl || ""}
          onUploadComplete={(url) => onPhotoUpload && onPhotoUpload(url)}
          folder="student_photos"
          className="w-52 h-52 object-cover"
          disabled={!isEditing}
        />
      </div>
    </div>
  );
}
